


























































































import SettlingComponent from './components/financialSettlement/SettlingComponent.vue';
import ReceivedComponent from './components/financialSettlement/ReceivedComponent.vue';
import UnsettledComponent from './components/financialSettlement/UnsettledComponent.vue';
import { checkSubmissionApi, getSubmissionStatusApi, getAgentBdContactInfoApi } from '@/api/index';
import { Component, Vue, Ref } from 'vue-property-decorator';

@Component({
  name: 'financialSettlement',
  components: {
    SettlingComponent,
    ReceivedComponent,
    UnsettledComponent,
  }
})
export default class extends Vue {
  // 未结算 结算中 已收款
  @Ref('unsettledRef')
  public unsettledRef!: UnsettledComponent;
  @Ref('settlingRef')
  public settlingRef!: SettlingComponent;
  @Ref('receivedRef')
  public receivedRef!: ReceivedComponent;

  public submitSettlementTips = '';
  public activeName: string = 'Unsettled';
  public sattlementStatus: number | string = '';
  public bdContactInfo: any = {
    email: '',
    isGearAgent: true
  };

  public mounted() {
    this.checkSubmission();
    this.getSubmissionStatus();
    this.getAgentBdContactInfo();
  }

  public get showSettlementMask() {
    return this.bdContactInfo && this.bdContactInfo.isGearAgent === false;
  }

  public async getSubmissionStatus() {
    try {
      const { data } = await getSubmissionStatusApi();
      this.sattlementStatus = data.data;
      if (data.data === 1) {
        this.activeName = 'Settling';
        this.settlingRef.getDatas();
      } else if (data.data === 2) {
        this.activeName = 'Received';
        this.receivedRef.getDatas();
      }
    } catch (error) {
      //
    }
  }

  public async checkSubmission() {
    try {
      await checkSubmissionApi();
    } catch(err: any) {
      console.log(err);
      this.submitSettlementTips = err.message;
    }
  }

  public async getAgentBdContactInfo() {
    try {
      const { data } = await getAgentBdContactInfoApi();
      this.bdContactInfo = data.data || {};
    } catch (error) {
      //
    }
  }

  // 未结算 结算中 已收款
  public handleTabClick(e: any) {
    const name = e.target.dataset.name;
    if (name) {
      this.activeName = name;
      if (name === 'Unsettled') {
        this.unsettledRef.getDatas();
        this.unsettledRef.checkHasSettling();
      } else if (name === 'Settling') {
        this.settlingRef.getDatas();
      } else if (name === 'Received') {
        this.receivedRef.getDatas();
      }
    }
  }

}
